let namePatterns = [];

export function normalizeAgentInput(s) {
  return s.replace(/[[(\])]/gi,' ').replace(/[^ -~]+/g,'').replace(/\s+/g,' ').trim();
}

export function initializePatterns(patterns) {
  namePatterns = patterns;
}

export function splitNameAndVersion(s,testFlag = false) {
  let result = [];
  if (!s || s.length === 0) {
    return result;
  }
  let s2 = normalizeAgentInput(s);
  let ii = 0;
  for (ii = 0; ii < namePatterns.length; ii++) {
    let patternObj = namePatterns[ii];
    let m = patternObj.pattern.exec(s2);
    if (m !== null) {
      for (let jj = 0; jj < patternObj.order.length; jj++) {
        if (Number.isInteger(patternObj.order[jj])
            && m.length > patternObj.order[jj] + 1
            // capture groups can be null or undefined
            && typeof(m[patternObj.order[jj] + 1]) === "string") {
          result.push(m[patternObj.order[jj] + 1].trim());
        } else {
          result.push(patternObj.order[jj]);
        }
      }
      if (patternObj.hasOwnProperty("debug")) {
        console.log(s + " => " + s2 + " => " + result);
      }
      break;
    } 
  }

  if (ii === namePatterns.length) {
    ii = -1;
    result = ["Unknown",s];
  }

  if (testFlag) {
    let pattern = ii >= 0 ? namePatterns[ii].pattern : "none";
    return {result: result, pattern: pattern, idx: ii};
  } 
  return result;
}

// assumes the key to sort by is in a.id and b.id
const versionPattern = /^(.*) - ([0-9.\-_:]*)$/;
export function cmpVersions (a,b) {
  a = a.hasOwnProperty('id') ? a.id : (a.hasOwnProperty('name') ? a.name : a);
  b = b.hasOwnProperty('id') ? b.id : (b.hasOwnProperty('name') ? b.name : b);
  
  let m1 = versionPattern.exec(a);
  let m2 = versionPattern.exec(b);

  if (!m1 && !m2) {
    return a.localeCompare(b);
  } else if (!m1 && m2) {
    return 1;
  } else if (m1 && !m2) {
    return -1;
  }

  if (m1[1] !== m2[1]) {
    return m1[1].localeCompare(m2[1]);
  }

  var i, diff;
  m1[2] = m1[2].replace(/-|_|:/g,'.');
  m2[2] = m2[2].replace(/-|_|:/g,'.');
  var regExStrip0 = /(\.0+)+$/;
  var segmentsA = m1[2].replace(regExStrip0, '').split('.');
  var segmentsB = m2[2].replace(regExStrip0, '').split('.');
  var l = Math.min(segmentsA.length, segmentsB.length);

  for (i = 0; i < l; i++) {
    diff = parseInt(segmentsA[i], 10) - parseInt(segmentsB[i], 10);
    if (diff) {
      return diff;
    }
  }
  return segmentsA.length - segmentsB.length;
}

